"use client";

import { signIn, useSession } from "next-auth/react";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import googleLogo from "../../public/svgs/google.svg";
import GoogleTerms from "./register/GoogleTerms";

const NewLogin = ({ providers }) => {
  const router = useRouter();
  const { data: session, status } = useSession();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (status === "authenticated" && session?.user?.id) {
      router.push(`/user/${session?.user?.id}/profile/edit`);
    }
  }, [status, session, router]);

  const handleSignIn = async (providerId) => {
    setIsLoading(true);
    setError("");
    try {
      const result = await signIn(providerId, {
        callbackUrl: "/auth/register/register-email",
        redirect: false,
      });

      if (result?.error) {
        setError("Sign in failed. Please try again.");
      } else if (result?.url) {
        router.push(result.url);
      }
    } catch (error) {
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    <div>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      <div>
        {providers &&
          Object.values(providers).map((provider) =>
            provider.name === "Credentials" ? null : (
              <React.Fragment key={provider.name}>
                <div className="flex flex-col items-center justify-center">
                  <button
                    onClick={() => handleSignIn(provider.id)}
                    className="flex items-center gap-[10px] justify-center w-[247px] md:w-[483px] md:h-[43px] h-[35px] border-[1px] border-[#000] rounded-[30px] mb-[20px] outline-none"
                    disabled={isLoading}
                  >
                    <Image
                      src={googleLogo}
                      height={25}
                      width={25}
                      alt="google"
                      className="md:w-[25px] md:h-[25px] w-[15px] h-[15px]"
                    />
                    {isLoading
                      ? "Loading..."
                      : `Continue with ${provider.name}`}
                  </button>
                  <span className="bg-[#ffff] text-center z-2 mb-[-12px] w-[20px]">
                    Or
                  </span>
                </div>
                <hr />
              </React.Fragment>
            )
          )}
      </div>
      <Link href="/auth/login">
        <button
          type="submit"
          className="flex items-center gap-[10px] justify-center w-[247px] md:w-[483px] h-[35px] md:h-[43px] outline-none border-[#000] rounded-[30px] border-[1px] my-[20px]"
          disabled={isLoading}
        >
          Continue with Email
        </button>
      </Link>
    </div>
    <GoogleTerms />
    </>
  );
};

export default NewLogin;
